import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    eSim: {
        backgroundColor: theme.palette.quaternary.main,
    },
    eSimContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 20,
    },
    eSimTitle: {
        color: theme.palette.secondary.main,
        fontSize: 16,
        marginLeft: theme.spacing(2),
    },
}));
